(() => {
  const main = document.querySelector('main:has(.lp-hero--safety)');
  if (!main) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const marquee = main.querySelector('lp-logo-marquee');
  marquee?.querySelector('button').addEventListener('click', event => {
    const paused = marquee.toggleAttribute('data-paused');
    const button = event.currentTarget;
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} press logos`);
    button.querySelector('path').setAttribute('d', paused ? 'm8 4 12 8-12 8z' : 'M6 4h4v16H6zm8 0h4v16h-4z');
  });
  if (motion.matches) return;
  // Animate only as each block enters, leaving content visible if scripting fails.
  const observer = new IntersectionObserver(entries => {
    entries.filter(entry => entry.isIntersecting).forEach(({target}) => {
      observer.unobserve(target);
      if (!motion.matches) target.animate([{opacity:0,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}], {duration:500,easing:'ease-out'});
    });
  }, {threshold:.2});
  main.querySelectorAll('.lp-overview__item').forEach(item => observer.observe(item));
})();
